import { Filters, SimpleEnumType } from '@/types';
import { Staffs } from '@/modules/staffs/types';
import { ConferencesStatuses, ConferencesTypes } from '@/enums';

export namespace Conferences {
  export enum Pages {
    CONFERENCES = 'conferences',
    NEW_CONFERENCE = 'conference/new',
    EDIT_CONFERENCE = 'conference/:id/edit',
    CONFERENCE_DETAIL = 'conference'
  }

  export interface Conference {
    [key: string]: unknown,
    conferences_title: string,
    created_at: string,
    id: number,
    name_organization: string,
    number: number,
    order_number: number,
    price: string,
    status: SimpleEnumType<ConferencesStatuses>,
    type: SimpleEnumType<ConferencesTypes>
  }

  export interface Nomenclature {
    id: number;
    title: string;
    code: string;
    price: string;
    nomenclature: string;
    min_staff_count: number;
    max_staff_count: number;
  }

  export interface Users {
    birthday: string,
    email: string,
    full_name: string,
    id: number,
    position: string,
    user_id: number
    phone: string,
  }
  export interface NewConferenceRespone {
    conference?: {
      title: string
    }
    title: string,
    url: string,
    start_registration_time: string,
    start_registration_date: string,
    image_path: string,
    image_original_name: string,
    id: number,
    end_registration_time: string,
    description: string,
    nomenclatures: Nomenclature[],
    end_registration_date: string,
    status: {
      id: number,
      slug: string,
      name: string,
    },
    type: {
      id: number,
      slug: string,
      name: string,
    }
  }

  export interface NewConference {
    organization_id: number,
    conference_id: number,
    nomenclature_id?: number,
    users: Conferences.AddUser[],
    organization_print: string,
    type: {
      id: number,
      slug: string,
      name: string,
    },
  }

  export interface AddUser extends Partial<Staffs.Staff> {
    full_name: string | null,
    birthday: string | null,
    email: string,
    position: string | null,
    phone: string | null,
    user_id?: number | null,
  }

  export interface ConferenceDetail {
    conference: {
      description: string,
      id: number,
      title: string,
      nomenclatures: Nomenclature[],
      type: {
        id: number,
        slug: string,
        name: string,
      }
    },
    date: string,
    id: number,
    number: number,
    nomenclature: Nomenclature,
    organization: {
      id: number,
      name_organization: string,
    },
    status: SimpleEnumType<ConferencesStatuses>,
    users: AddUser[],
    order_external_number: number,
    order_id: number | null,
    comment: string,
    organization_print: string,
  }
}

export interface ConferencesFilters extends Filters {
  [key: string]: unknown,
}
